import thunk from 'redux-thunk';
import reportError from 'ha/helpers/bugsnag/reportError';

import inboxRealtimeMiddleware from 'ha/pages/Inbox/middlewares/realtime';
import talkRealtimeMiddleware from 'ha/pages/Talk/middlewares/realtime';

import {
  delayWeWantToPayModal,
  openWeWantToPayModal,
} from 'ha/modules/WeWantToPay/middleware';
import { urlLocationMiddleware } from 'ha/modules/URLLocationHandler';
import { newTabMiddleware } from 'ha/modules/NewTabHandler';
import alerts from 'ha/modules/Alertbar/middleware';
import createAnalyticsMiddleware from 'ha/modules/Analytics/middleware';
import fixIosCaretIssueMiddleware from 'ha/modules/UI/middlewares/fixIosCaretIssue';
import hotjarMiddleware from 'ha/modules/Hotjar';
import realtimeMessagingMiddleWare from 'ha/modules/RealtimeMessaging/middleware';
import inboxCounterMiddleware from 'ha/modules/InboxCounter/middleware';

import crashReporter from './middlewares/crashReporter';
import queryParamsMiddleware from './middlewares/queryParams';
import scroll from './middlewares/scroll';

import { getChannelId } from './getChannelId';
import sanitizeState from './sanitizeState';

export default ({ debug, errorTracker, history, services }) => {
  const commonMiddlewares = [thunk.withExtraArgument(services)];

  if (!process.browser) {
    return commonMiddlewares;
  }

  return [
    ...commonMiddlewares,
    createAnalyticsMiddleware(debug),
    hotjarMiddleware,
    urlLocationMiddleware(),
    newTabMiddleware(),
    queryParamsMiddleware(history),
    delayWeWantToPayModal,
    openWeWantToPayModal,
    crashReporter(errorTracker, sanitizeState),
    alerts,
    scroll,
    fixIosCaretIssueMiddleware(global.document.body),
    realtimeMessagingMiddleWare({
      debug,
      onError: reportError,
      getChannelId,
    }),
    inboxRealtimeMiddleware,
    talkRealtimeMiddleware,
    inboxCounterMiddleware,
  ];
};
